<div class="contest-header__wrapper">
  <div class="contest-header__actions">
    <button class="contest-header__play-button"
      (click)="playContest()">
      <div>{{ "contest.play" | translate }}</div>
      @if (!startingPlay) {
        <mat-icon svgIcon="play-rounded-fill"></mat-icon>
      } @else {
        <mat-spinner diameter="24"></mat-spinner>
      }
    </button>
    <div class="contest-header__actions-data">
      <div class="contest-header__remaining-time">
        <mat-icon svgIcon="timer"></mat-icon>
        <div>{{ daysLeft }} {{ 'contest.days_left' | translate }}</div>
      </div>
      <p class="contest-header__best-player">
        <span>{{ "contest.outmatch" | translate }}</span>
        <span class="contest-header__best-player-name"> {{ userToBest }}</span>
        <span>&nbsp;!</span>
      </p>
    </div>
  </div>
  <!--<div class="contest-header__score">
  <div class="contest-header__user">
    <div class="contest-header__user-label">
      <mat-icon svgIcon="person-outlined-fill"></mat-icon>
      <div>{{ "contest.user_score" | translate }}</div>
    </div>
    <div class="contest-header__user-score">
      <div>
        <span>{{ userScore }}</span>
        <span class="contest-header__user-max-score">&nbsp;/&nbsp;1000</span>
      </div>
      <mat-icon svgIcon="diamond"></mat-icon>
    </div>
  </div>
  <div class="contest-header__community">
    <div class="contest-header__community-label">
      <mat-icon svgIcon="diversity-outlined-fill"></mat-icon>
      <div>{{ "contest.community_score" | translate }}</div>
    </div>
    <div class="contest-header__community-score">
      <div>
        <span>{{ communityScore }}</span>
        <span class="contest-header__community-max-score">&nbsp;/&nbsp;100&nbsp;000</span>
      </div>
      <mat-icon svgIcon="diamond"></mat-icon>
    </div>
  </div>
</div>-->
</div>